/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface LinkedInSignatureCreate {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name: string;
  /**
     * @minLength 1
     * @maxLength 200
     */
  body_text: string;
}
